import React from "react";
import { fmtAbbr } from "../../components/terminal/format.js";
import ItemActions, { CTX } from "../../components/terminal/ItemActions.jsx";

/* Top counterparties (top half) + FX windows (bottom half) — single
   right-rail pane on the Overview screen. Two splits with their own
   pane-heads share one column so they read as a single rail. */

export default function PartiesPane({ parties = [], fxWindows = [] }) {
  return (
    <div className="term-pane">
      <div className="term-pane-head">
        Counterparties · top by 30d volume
        <span className="meta"><b>{parties.length}</b></span>
      </div>
      <div className="term-pane-body" style={{ maxHeight:"52%", flex:"none" }}>
        {parties.map((p, i) => {
          const vol = parseFloat(p.volume_30d_usd) || 0;
          const net = parseFloat(p.net_30d_usd) || 0;
          return (
            <div
              key={i}
              className="term-has-ctx"
              style={{
                display:"grid", gridTemplateColumns:"22px 1fr 80px 60px", gap:8, alignItems:"center",
                padding:"0 14px", height:36, borderBottom:"1px solid var(--term-line-dim)",
                cursor:"pointer", position:"relative",
              }}
            >
              <span className="mono" style={{ fontSize:9.5, color:"var(--term-ink-3)", textAlign:"center", letterSpacing:"0.04em" }}>{p.iso}</span>
              <span style={{ display:"flex", flexDirection:"column", gap:2, minWidth:0 }}>
                <span style={{ fontSize:11.5, color:"var(--term-ink-1)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</span>
                <span className="mono" style={{ fontSize:9.5, color:"var(--term-ink-3)", letterSpacing:"0.04em", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                  {p.channel_id} · {p.channel_label}
                </span>
              </span>
              <span className="mono" style={{ textAlign:"right", fontSize:11 }}>{fmtAbbr(vol).replace("$","$").replace("M","M").replace("K","K")}</span>
              <span className="mono" style={{ textAlign:"right", fontSize:10.5, color: net >= 0 ? "var(--term-green)" : "var(--term-red)" }}>
                {net >= 0 ? "+" : "−"}{fmtAbbr(Math.abs(net)).replace("$","$")}
              </span>
              <span style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", background:"var(--term-bg-pane-2)", padding:"2px" }}>
                <ItemActions actions={CTX.counterparty(p.name)} />
              </span>
            </div>
          );
        })}
      </div>

      <div className="term-pane-head term-pane-split">
        FX Windows · today
        <span className="meta">{fxWindows.length} pairs · {fxWindows.some((f) => f.auto_rule_active) ? "auto-rule on" : "manual"}</span>
      </div>
      <div className="term-pane-body" style={{ flex:1 }}>
        {fxWindows.map((f, i) => {
          const cls = f.delta_24h_pct > 0 ? "var(--term-green)" : f.delta_24h_pct < 0 ? "var(--term-red)" : "var(--term-ink-3)";
          return (
            <div key={i} style={{ display:"grid", gridTemplateColumns:"70px 78px 1fr 56px", gap:10, alignItems:"center", padding:"0 14px", height:32, borderBottom:"1px solid var(--term-line-dim)", fontSize:11 }}>
              <span className="mono" style={{ fontWeight:500, letterSpacing:"0.04em" }}>{f.pair}</span>
              <span className="mono" style={{ textAlign:"right" }}>{f.rate}</span>
              <span style={{ position:"relative", height:8, background:"var(--term-line-dim)", border:"1px solid var(--term-ink-4)" }}>
                <span style={{ position:"absolute", top:-1, bottom:-1, background:"var(--term-green)", opacity:0.55, left:`${f.window_optimal_start * 100}%`, right:`${(1 - f.window_optimal_end) * 100}%` }} />
                <span style={{ position:"absolute", top:-3, bottom:-3, width:1, background:"var(--term-ink-1)", boxShadow:"0 0 4px var(--term-ink-1)", left:`${f.window_now * 100}%` }} />
              </span>
              <span className="mono" style={{ textAlign:"right", fontSize:10.5, color: cls }}>
                {f.delta_24h_pct > 0 ? "+" : f.delta_24h_pct < 0 ? "−" : " "}{Math.abs(f.delta_24h_pct).toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
